import styled from 'styled-components';
const S = {};

const ContainerBgColor = ({ theme: { $iwgPaymentsContainerBgColor } }) => `${$iwgPaymentsContainerBgColor}`;
const SwitchBgColor = ({ theme: { $iwgPaymentSwitchBgColor } }) => `${$iwgPaymentSwitchBgColor}`;
const SwitchTextColor = ({ theme: { $iwgPaymentSwitchTextColor } }) => `${$iwgPaymentSwitchTextColor}`;
const SwitchBgColorActive = ({ theme: { $iwgPaymentSwitchBgColorActive } }) => `${$iwgPaymentSwitchBgColorActive}`;
const SwitchTextColorActive = ({ theme: { $iwgLightTextColor } }) => `${$iwgLightTextColor}`;
const PaymentBgColor = ({ theme: { $iwgPaymentBgColor } }) => `${$iwgPaymentBgColor}`;

S.AccountPaymentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${ContainerBgColor};
`;

S.PaymentsContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-top: 0.5rem;
`;

S.PaymentSwitcher = styled.div`
  flex: 1 0 auto;
  display: flex;
  margin: 0 1rem;
`;

S.PaymentSwitch = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.5rem 0 0 0;
  padding: 0.75rem;
  background-color: ${SwitchBgColor};
  color: ${SwitchTextColor};
  text-transform: uppercase;
  font-size: 0.75rem;
  font-weight: 700;

  &:hover {
    cursor: pointer;
  }
  &.active {
    color: ${SwitchTextColorActive};
    background-color: ${SwitchBgColorActive};
  }
  &:last-of-type {
    border-radius: 0 0.5rem 0 0;
  }
`;

S.Payment = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: ${PaymentBgColor};
  padding: 1.33rem;
`;

S.PaymentTitle = styled.div`
  font-size: 1.33rem;
  font-weight: bold;
  margin-bottom: 1.4rem;
`;

export default S;
